module.exports = __webpack_public_path__ + "img/39.e7b44e70.png";